import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "design-system/molecules/Select"
import { FileText, Gauge, Info, List, Tags } from "lucide-react"
import { useTranslation } from "react-i18next"
import { GoalType, GoalTypeEnum } from "schema"

type GoalTypeSelectProps = {
  value: GoalType
  onValueChange: (value: GoalType) => void
  disabled?: boolean
  className?: string
}

export const GoalTypeSelect = ({
  value,
  onValueChange,
  disabled,
  className,
}: GoalTypeSelectProps) => {
  const { t } = useTranslation()

  return (
    <Select
      value={value}
      onValueChange={(value) => onValueChange(value as GoalType)}
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="overflow-y-auto max-h-full">
        <SelectItem
          value={GoalTypeEnum.Classification}
          textValue={t("campaigns.goals.classification")}
          description={t("campaigns.goals.classificationDescription")}
          className="max-w-md"
        >
          <div className="flex items-center gap-2">
            <Tags className="size-4" />
            <span>{t("campaigns.goals.classification")}</span>
          </div>
        </SelectItem>
        <SelectItem
          value={GoalTypeEnum.Predefined}
          textValue={t("campaigns.goals.predefined")}
          description={t("campaigns.goals.predefinedDescription")}
          className="max-w-md"
        >
          <div className="flex items-center gap-2">
            <List className="size-4" />
            <span>{t("campaigns.goals.predefined")}</span>
          </div>
        </SelectItem>
        <SelectItem
          value={GoalTypeEnum.NPS}
          textValue={t("campaigns.goals.npsLike")}
          description={t("campaigns.goals.npsLikeDescription")}
          className="max-w-md"
        >
          <div className="flex items-center gap-2">
            <Gauge className="size-4" />
            <span>{t("campaigns.goals.npsLike")}</span>
          </div>
        </SelectItem>
        <SelectItem
          value={GoalTypeEnum.Informative}
          textValue={t("campaigns.goals.informative")}
          description={t("campaigns.goals.informativeDescription")}
          className="max-w-md"
        >
          <div className="flex items-center gap-2">
            <Info className="size-4" />
            <span>{t("campaigns.goals.informative")}</span>
          </div>
        </SelectItem>
        <SelectItem
          value={GoalTypeEnum.Open}
          textValue={t("campaigns.goals.open")}
          description={t("campaigns.goals.openDescription")}
          className="max-w-md"
        >
          <div className="flex items-center gap-2">
            <FileText className="size-4" />
            <span>{t("campaigns.goals.open")}</span>
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  )
}
